import {
  assignContactPurpose,
  isPrimaryBillingContact
} from 'CustomerContacts/utils/contactPurposes'
import { Contact, CustomerFormFieldsData } from './types'

/**
 * "Same as billing" covers the shipping contact too, so when it's ticked the
 * primary billing contact goes to the API as the shipping contact.
 */
export const toCustomerContactsFromForm = (
  data: Pick<CustomerFormFieldsData, 'contacts' | 'isShippingSameAsBilling'>
): Array<Omit<Contact, 'id'>> => {
  const primaryContact = data.contacts.find(isPrimaryBillingContact)
  const contacts =
    data.isShippingSameAsBilling && primaryContact
      ? assignContactPurpose(data.contacts, primaryContact.id, 'SHIPPING')
      : data.contacts

  return contacts.map(contact => ({
    name: contact.name.trim(),
    email: contact.email.trim(),
    purposes: contact.purposes,
    notificationSubscriptions: contact.notificationSubscriptions
  }))
}
